import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import HuertasTabla from './HuertasTabla.jsx';

const HuertasListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Administración de huertas</Link></li>
        <li className="breadcrumb-item active">Listado de huertas</li>
      </ol>
      <h1 className="page-header">Administración de huertas <small></small></h1>
      <Panel>
        <PanelHeader>Huertas registradas</PanelHeader>
        <PanelBody>
            <HuertasTabla/>
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default HuertasListar;
